import { createStyles } from 'antd-style';

import { ThemeFont, ThemeSpaces } from '../../theme';
import {
  flex1,
  listCard,
  listCardActive,
  listCardHover,
  spaceBetween,
} from '../../styles/mixins';
import { responsiveMdVsLg } from '../../styles/responsiveMixins';

export const useShipmentAssetsInventoryStyles = createStyles(({ token }) => ({
  assetsInventory: {
    padding: ThemeSpaces.SPACE_NORM,
  },
  assetsInventoryEntry: {
    ...listCard(token),
    position: 'relative',

    ...responsiveMdVsLg(
      {
        padding: `${ThemeSpaces.SPACE_SM}px ${ThemeSpaces.SPACE_NORM}px`,
        height: 120,
      },
      {
        padding: `${ThemeSpaces.SPACE_SM}px ${ThemeSpaces.SPACE_NORM_20}px`,
        height: 80,
      }
    ),

    '&:hover': {
      ...listCardHover(),
    },
    '&:active': {
      ...listCardActive(),
    },

    '> .ant-row': {
      width: '100%',
    },
  },
  assetEntryLabel: {
    ...responsiveMdVsLg(
      { ...spaceBetween(ThemeSpaces.SPACE_SM, 'vertical') },
      { ...spaceBetween(ThemeSpaces.SPACE_XXS, 'vertical') }
    ),

    '.label': {
      marginBottom: ThemeSpaces.SPACE_XXS,
    },
    '.text': {
      fontSize: ThemeFont.FONT_SIZE_SM_PLUS,
    },
  },
  col1: {
    ...responsiveMdVsLg(
      { width: '100%', marginBottom: ThemeSpaces.SPACE_SM },
      { width: 200 }
    ),
  },
  cols23: {
    ...responsiveMdVsLg(
      {
        width: '100%',
        '> .ant-row': { ...spaceBetween(ThemeSpaces.SPACE_SM, 'vertical') },
      },
      {
        ...flex1(),
        '> .ant-row': { ...spaceBetween(ThemeSpaces.SPACE_SM, 'vertical') },
      }
    ),
  },
  col2: {
    ...responsiveMdVsLg({ width: '60%' }, { width: 220 }),
  },
  col3: {
    ...responsiveMdVsLg({ width: '40%' }, { ...flex1() }),
  },
}));
